export const MODIFY_TEAM_INFO = 'MODIFY_TEAM_INFO';

export function modifyTeamInfo(teamInfo){
    return{
        type: MODIFY_TEAM_INFO,
        mainState: {
            teamInfo: teamInfo
        }
    }
}